import {
  Box,
  Button,
  Group,
  Paper,
  Space,
  Stack,
  Tabs,
  Text,
} from "@mantine/core";
import classes from "../../styles/elements.module.css";
import { IconBuilding, IconGauge, IconUser } from "@tabler/icons-react";
import PropertyList from "./properties/PropertyList";
import { useLayoutStore } from "../../store/layout.store";
import { useRegisterStore } from "../../store/register.store";
import { REGISTRATION_SIDEBAR_SELECTOR } from "../../constants";
import ClientList from "./clients/ClientList";

export default function RegisterView() {
  const { setAsideBarOpened } = useLayoutStore((state) => state);
  const setSidebarSelector = useRegisterStore(
    (state) => state.setRegistrationSidebarSelectorState
  );

  return (
    <Box flex={1} px={"xl"} py={"lg"}>
      <Stack gap={"lg"}>
        <Text c="#7A7A7A" size="xl" fw={800}>
          Registration
        </Text>
        <Paper radius={"sm"} p={"md"} withBorder bg={"transparent"}>
          <Text c="#7A7A7A" fw={600}>
            Quick Actions
          </Text>
          <Space h="sm" />
          <Group>
            <Button
              variant="light"
              color="red"
              leftSection={<IconBuilding size={16} />}
              onClick={() => {
                setSidebarSelector(
                  REGISTRATION_SIDEBAR_SELECTOR.propertyRegistration
                );
                setAsideBarOpened(true);
              }}
            >
              Add property
            </Button>
            <Button
              variant="light"
              color="cyan"
              leftSection={<IconGauge size={16} />}
              onClick={() => {
                setSidebarSelector(
                  REGISTRATION_SIDEBAR_SELECTOR.meterRegistration
                );
                setAsideBarOpened(true);
              }}
            >
              Add meter
            </Button>
            <Button
              variant="light"
              color="purple"
              leftSection={<IconUser size={16} />}
              onClick={() => {
                setSidebarSelector(
                  REGISTRATION_SIDEBAR_SELECTOR.clientRegistration
                );
                setAsideBarOpened(true);
              }}
            >
              Add client
            </Button>
          </Group>
        </Paper>
        <Tabs
          variant="unstyled"
          defaultValue="properties"
          classNames={{ tab: classes.tab }}
        >
          <Tabs.List grow>
            <Tabs.Tab value="properties">Properties</Tabs.Tab>
            <Tabs.Tab value="meters">Meters</Tabs.Tab>
            <Tabs.Tab value="clients">Clients</Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="properties">
            <PropertyList />
          </Tabs.Panel>

          <Tabs.Panel value="meters">Meters tab content</Tabs.Panel>

          <Tabs.Panel value="clients">
            <ClientList />
          </Tabs.Panel>
        </Tabs>
      </Stack>
    </Box>
  );
}
